import React from 'react'

const PostDetails = () => {
  return (
    <div style={{marginTop:"500px"}}>
      <h1>post details page</h1>
    </div>
  )
}

export default PostDetails
